<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Duplicate invoice management system" name="description"/>
      <meta content="County System" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.svg" rel="shortcut icon">
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Duplicate Invoice Management</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                      <li class="breadcrumb-item"><a>Admin Tools</a></li>
                      <li class="breadcrumb-item active">Duplicate Management</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tab Navigation -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link"
                           :class="{ active: activeTab === 'duplicates' }"
                           @click="activeTab = 'duplicates'"
                           href="javascript:void(0);">
                          <i class="bx bx-copy me-2"></i>
                          Find Duplicates
                          <span v-if="duplicatesFound > 0" class="badge bg-danger ms-2">{{ duplicatesFound }}</span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link"
                           :class="{ active: activeTab === 'archived' }"
                           @click="activeTab = 'archived'"
                           href="javascript:void(0);">
                          <i class="bx bx-archive me-2"></i>
                          Archived Invoices
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Duplicates Tab -->
            <div v-if="activeTab === 'duplicates'">
              <!-- Summary Cards -->
              <div class="row mb-4">
                <div class="col-md-3">
                  <div class="card mini-stats-wid border-warning">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Duplicate Records</p>
                          <h4 class="mb-0 text-warning">{{ duplicatesFound }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                            <span class="avatar-title">
                              <i class="bx bx-copy font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-info">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Duplicate Groups</p>
                          <h4 class="mb-0 text-info">{{ duplicateGroups }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                            <span class="avatar-title">
                              <i class="bx bx-group font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-danger">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Total Amount</p>
                          <h4 class="mb-0 text-danger">{{ formatPrice(duplicateAmount) }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-danger">
                            <span class="avatar-title">
                              <i class="bx bx-money font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="card mini-stats-wid border-success">
                    <div class="card-body">
                      <div class="d-flex">
                        <div class="flex-grow-1">
                          <p class="text-muted fw-medium mb-2">Selected</p>
                          <h4 class="mb-0 text-success">{{ selectedInvoices.length }}</h4>
                        </div>
                        <div class="flex-shrink-0 align-self-center">
                          <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                            <span class="avatar-title">
                              <i class="bx bx-check-square font-size-24"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filters -->
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light">
                      <h4 class="card-title mb-0">Search for Duplicate Invoices</h4>
                    </div>
                    <div class="card-body">
                      <div class="row g-3">
                        <div class="col-md-3">
                          <label class="form-label">From Date:</label>
                          <input v-model="filters.dateFrom"
                                 class="form-control"
                                 type="date"
                                 @change="clearResults">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">To Date:</label>
                          <input v-model="filters.dateTo"
                                 class="form-control"
                                 type="date"
                                 @change="clearResults">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Revenue Stream:</label>
                          <select class="form-select" v-model="filters.incomeTypePrefix" @change="clearResults">
                            <option value="">All Streams</option>
                            <option v-for="prefix in prefixes" :key="prefix.incomeTypePrefix" :value="prefix.incomeTypePrefix">
                              {{ prefix.stream }} ({{ prefix.incomeTypePrefix }})
                            </option>
                          </select>
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Sub County:</label>
                          <select class="form-select" v-model="filters.subCountyID" @change="clearResults">
                            <option value="">All Sub Counties</option>
                            <option v-for="county in subCounties" :key="county.subCountyID" :value="county.subCountyID">
                              {{ county.subCountyName }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- Quick Date Filters -->
                      <div class="mt-3">
                        <label class="form-label">Quick Filters:</label>
                        <div class="btn-group me-3" role="group">
                          <button @click="setDateRange('today')" type="button" class="btn btn-outline-primary btn-sm">Today</button>
                          <button @click="setDateRange('week')" type="button" class="btn btn-outline-primary btn-sm">This Week</button>
                          <button @click="setDateRange('month')" type="button" class="btn btn-outline-primary btn-sm">This Month</button>
                        </div>

                        <button @click="searchDuplicates()"
                                type="button"
                                class="btn btn-primary"
                                :disabled="loading || !filters.dateFrom || !filters.dateTo">
                          <i class="bx bx-search me-1"></i>
                          <span v-if="loading">Searching...</span>
                          <span v-else>Find Duplicates</span>
                        </button>

                        <!-- AUTO ARCHIVE BUTTON -->
                        <button @click="openAutoArchiveModal()"
                                type="button"
                                class="btn btn-warning ms-2"
                                :disabled="autoArchiveInProgress || autoArchivePaused">
                          <i class="bx bx-time me-1"></i>
                          <span v-if="autoArchiveInProgress">Running...</span>
                          <span v-else-if="autoArchivePaused">Paused</span>
                          <span v-else>Auto Archive</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Results Table -->
              <div v-if="duplicates.length > 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-white border-bottom d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">
                        Duplicate Invoices Found ({{ duplicatesFound }} duplicates to remove)
                      </h4>
                      <div class="btn-group">
                        <button @click="selectAllDuplicates()"
                                type="button"
                                class="btn btn-sm btn-outline-primary"
                                :disabled="duplicatesOnly.length === 0">
                          <i class="bx bx-select-multiple me-1"></i>
                          Select All Duplicates
                        </button>
                        <button @click="clearSelection()"
                                type="button"
                                class="btn btn-sm btn-outline-secondary"
                                :disabled="selectedInvoices.length === 0">
                          <i class="bx bx-x me-1"></i>
                          Clear Selection
                        </button>
                        <button @click="showBulkArchiveConfirmation()"
                                type="button"
                                class="btn btn-sm btn-danger"
                                :disabled="selectedInvoices.length === 0 || archiving">
                          <i class="bx bx-archive me-1"></i>
                          <span v-if="archiving">Archiving...</span>
                          <span v-else>Archive Selected ({{ selectedInvoices.length }})</span>
                        </button>
                      </div>
                    </div>
                    <div class="card-body p-0">
                      <div class="table-responsive">
                        <table class="table table-hover mb-0">
                          <thead class="table-light">
                          <tr>
                            <th width="50">
                              <input type="checkbox"
                                     class="form-check-input"
                                     @change="toggleSelectAllVisible"
                                     :checked="allVisibleDuplicatesSelected">
                            </th>
                            <th>Bill No</th>
                            <th>Type</th>
                            <th>Agent</th>
                            <th>Fee Description</th>
                            <th>Amount</th>
                            <th>Customer</th>
                            <th>Date Created</th>
                            <th>Group Size</th>
                            <th>Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in duplicates"
                              :key="item.billNo"
                              :class="{
                                  'table-success': item.record_type === 'ORIGINAL',
                                  'table-warning': item.record_type === 'DUPLICATE' && selectedInvoices.includes(item.billNo),
                                  'table-light': item.record_type === 'DUPLICATE'
                                }">
                            <td>
                              <input v-if="item.record_type === 'DUPLICATE'"
                                     type="checkbox"
                                     class="form-check-input"
                                     :value="item.billNo"
                                     v-model="selectedInvoices">
                              <span v-else class="text-success fw-bold">✓</span>
                            </td>
                            <td>
                              <strong>{{ item.billNo }}</strong>
                              <br>
                              <small class="text-muted">{{ item.incomeTypePrefix }}</small>
                            </td>
                            <td>
                                <span v-if="item.record_type === 'ORIGINAL'"
                                      class="badge bg-success">ORIGINAL</span>
                              <span v-else class="badge bg-warning text-dark">DUPLICATE</span>
                            </td>
                            <td>
                              <strong>{{ item.names }}</strong>
                              <br>
                              <small class="text-muted">ID: {{ item.idNo }}</small>
                            </td>
                            <td>
                              {{ item.feeDescription }}
                              <br>
                              <small class="text-muted">{{ item.subCountyName }} - {{ item.wardName }}</small>
                            </td>
                            <td>
                              <strong class="text-danger">{{ formatPrice(item.detailAmount) }}</strong>
                            </td>
                            <td>
                              {{ item.customers }}
                              <br>
                              <small class="text-muted">{{ item.customerPhoneNumber }}</small>
                            </td>
                            <td>
                              {{ formatDateTime(item.dateCreated) }}
                            </td>
                            <td>
                              <span class="badge bg-info">{{ item.group_size }} total</span>
                            </td>
                            <td>
                              <button v-if="item.record_type === 'DUPLICATE'"
                                      @click="showSingleArchiveConfirmation(item.billNo)"
                                      class="btn btn-sm btn-danger"
                                      :disabled="archiving">
                                <i class="bx bx-trash"></i>
                              </button>
                              <span v-else class="text-muted">Keep</span>
                            </td>
                          </tr>
                          </tbody>
                          <tfoot v-if="duplicates.length > 0" class="table-dark">
                          <tr>
                            <th colspan="5">
                              <strong>{{ duplicates.length }} records ({{ duplicatesFound }} duplicates)</strong>
                            </th>
                            <th>
                              <strong>{{ formatPrice(duplicateAmount) }}</strong>
                            </th>
                            <th colspan="4"></th>
                          </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Archived Tab -->
            <div v-if="activeTab === 'archived'">
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-header bg-light d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Archived Invoices</h4>
                      <button @click="loadArchivedInvoices()"
                              type="button"
                              class="btn btn-primary"
                              :disabled="loadingArchived">
                        <i class="bx bx-refresh me-1"></i>
                        <span v-if="loadingArchived">Loading...</span>
                        <span v-else>Refresh</span>
                      </button>
                    </div>
                    <div class="card-body">
                      <!-- Archive Filters -->
                      <div class="row g-3 mb-3">
                        <div class="col-md-3">
                          <label class="form-label">From Date:</label>
                          <input v-model="archiveFilters.dateFrom"
                                 class="form-control"
                                 type="date">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">To Date:</label>
                          <input v-model="archiveFilters.dateTo"
                                 class="form-control"
                                 type="date">
                        </div>
                        <div class="col-md-3">
                          <label class="form-label">Revenue Stream:</label>
                          <select class="form-select" v-model="archiveFilters.incomeTypePrefix">
                            <option value="">All Streams</option>
                            <option v-for="prefix in prefixes" :key="prefix.incomeTypePrefix" :value="prefix.incomeTypePrefix">
                              {{ prefix.stream }}
                            </option>
                          </select>
                        </div>
                        <div class="col-md-3 d-flex align-items-end">
                          <button @click="loadArchivedInvoices()"
                                  type="button"
                                  class="btn btn-primary w-100">
                            <i class="bx bx-search me-1"></i>
                            Search Archives
                          </button>
                        </div>
                      </div>

                      <!-- Archived Table -->
                      <div v-if="archivedInvoices.length > 0" class="table-responsive">
                        <table class="table table-striped">
                          <thead>
                          <tr>
                            <th>Bill No</th>
                            <th>Amount</th>
                            <th>Customer</th>
                            <th>Archived Date</th>
                            <th>Archived By</th>
                            <th>Reason</th>
                            <th>Actions</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in archivedInvoices" :key="item.id">
                            <td>
                              <strong>{{ item.billNo }}</strong>
                              <br>
                              <small class="text-muted">{{ item.incomeTypePrefix }}</small>
                            </td>
                            <td>
                              <strong>{{ formatPrice(item.detailAmount) }}</strong>
                            </td>
                            <td>
                              {{ item.customers }}
                              <br>
                              <small class="text-muted">{{ item.customerPhoneNumber }}</small>
                            </td>
                            <td>
                              {{ formatDateTime(item.archivedDate) }}
                            </td>
                            <td>
                              {{ item.archivedBy }}
                            </td>
                            <td>
                              <small>{{ item.archiveReason }}</small>
                            </td>
                            <td>
                              <button @click="showRestoreConfirmation(item.billNo)"
                                      class="btn btn-sm btn-success"
                                      :disabled="restoring">
                                <i class="bx bx-refresh"></i>
                                Restore
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <!-- Pagination -->
                        <div v-if="pagination.total_pages > 1" class="d-flex justify-content-between align-items-center mt-3">
                          <div>
                            Showing {{ ((pagination.current_page - 1) * pagination.limit) + 1 }} -
                            {{ Math.min(pagination.current_page * pagination.limit, pagination.total_records) }}
                            of {{ pagination.total_records }} records
                          </div>
                          <nav>
                            <ul class="pagination pagination-sm mb-0">
                              <li class="page-item" :class="{ disabled: pagination.current_page <= 1 }">
                                <a @click="changePage(pagination.current_page - 1)" class="page-link" href="javascript:void(0);">Previous</a>
                              </li>
                              <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: page === pagination.current_page }">
                                <a @click="changePage(page)" class="page-link" href="javascript:void(0);">{{ page }}</a>
                              </li>
                              <li class="page-item" :class="{ disabled: pagination.current_page >= pagination.total_pages }">
                                <a @click="changePage(pagination.current_page + 1)" class="page-link" href="javascript:void(0);">Next</a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>

                      <div v-else-if="!loadingArchived" class="text-center py-4">
                        <i class="bx bx-archive text-muted" style="font-size: 48px;"></i>
                        <h5 class="mt-3">No Archived Invoices</h5>
                        <p class="text-muted">No archived invoices found for the selected criteria.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FIXED: Bulk Archive Confirmation Modal -->
            <div class="modal fade"
                 id="bulkArchiveConfirmationModal"
                 aria-labelledby="bulkArchiveConfirmationModalLabel"
                 aria-hidden="true"
                 data-bs-backdrop="true"
                 data-bs-keyboard="true">
              <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-warning text-dark">
                    <h5 class="modal-title" id="bulkArchiveConfirmationModalLabel">
                      <i class="bx bx-archive me-2"></i>
                      Confirm Bulk Archive Action
                    </h5>
                    <button type="button" class="btn-close" @click="closeBulkArchiveModal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div class="alert alert-warning border-0">
                      <div class="d-flex">
                        <div class="flex-shrink-0">
                          <i class="bx bx-info-circle font-size-16 text-warning me-3"></i>
                        </div>
                        <div class="flex-grow-1">
                          <h6 class="mb-1">Archive Multiple Duplicate Invoices</h6>
                          <p class="mb-0">
                            You are about to archive <strong class="text-danger">{{ selectedInvoices.length }}</strong> duplicate invoices.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div class="mb-4">
                      <h6>This action will:</h6>
                      <ul class="list-unstyled mt-2">
                        <li class="mb-2">
                          <i class="bx bx-check text-success me-2"></i>
                          Move the selected duplicates to archive tables
                        </li>
                        <li class="mb-2">
                          <i class="bx bx-check text-success me-2"></i>
                          Keep the original (first created) invoice active
                        </li>
                        <li class="mb-2">
                          <i class="bx bx-check text-success me-2"></i>
                          Remove duplicates from active billing system
                        </li>
                        <li class="mb-2">
                          <i class="bx bx-check text-success me-2"></i>
                          Allow you to restore them later if needed
                        </li>
                      </ul>
                    </div>

                    <div class="mb-3">
                      <label class="form-label fw-semibold">Archive Reason (Optional):</label>
                      <textarea v-model="bulkArchiveReason"
                                class="form-control"
                                rows="3"
                                placeholder="Enter reason for archiving these duplicate invoices..."
                                maxlength="500"></textarea>
                      <div class="text-muted small mt-1">{{ bulkArchiveReason.length }}/500 characters</div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeBulkArchiveModal">
                      <i class="bx bx-x me-1"></i>
                      Cancel
                    </button>
                    <button @click="executeBulkArchive"
                            type="button"
                            class="btn btn-danger"
                            :disabled="archiving">
                      <i class="bx bx-archive me-1" :class="{ 'bx-spin': archiving }"></i>
                      <span v-if="archiving">Archiving...</span>
                      <span v-else>Archive {{ selectedInvoices.length }} Invoices</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Single Archive Confirmation Modal -->
            <div class="modal fade" id="singleArchiveConfirmationModal" aria-labelledby="singleArchiveConfirmationModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-danger text-white">
                    <h5 class="modal-title" id="singleArchiveConfirmationModalLabel">
                      <i class="bx bx-trash me-2"></i>
                      Archive Duplicate Invoice
                    </h5>
                    <button type="button" class="btn-close btn-close-white" @click="closeSingleArchiveModal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div class="text-center mb-3">
                      <i class="bx bx-error-circle text-warning" style="font-size: 48px;"></i>
                    </div>
                    <p class="text-center">
                      Are you sure you want to archive invoice <strong class="text-danger">{{ currentArchiveBillNo }}</strong>?
                    </p>
                    <div class="alert alert-info">
                      <small>
                        <i class="bx bx-info-circle me-1"></i>
                        This will move the invoice to archive tables and remove it from the active billing system.
                        You can restore it later if needed.
                      </small>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Archive Reason (Optional):</label>
                      <input v-model="singleArchiveReason"
                             class="form-control"
                             type="text"
                             placeholder="Enter reason for archiving..."
                             maxlength="200">
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeSingleArchiveModal">
                      <i class="bx bx-x me-1"></i>
                      Cancel
                    </button>
                    <button @click="executeSingleArchive"
                            type="button"
                            class="btn btn-danger"
                            :disabled="archiving">
                      <i class="bx bx-trash me-1" :class="{ 'bx-spin': archiving }"></i>
                      <span v-if="archiving">Archiving...</span>
                      <span v-else>Archive Invoice</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Archive Progress Modal -->
            <div class="modal fade" id="archiveProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="archiveProgressModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-primary text-white">
                    <h5 class="modal-title" id="archiveProgressModalLabel">
                      <i class="bx bx-time-five me-2 bx-spin"></i>
                      Processing Archive Request
                    </h5>
                  </div>
                  <div class="modal-body">
                    <div class="mb-4">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="fw-semibold">Progress</span>
                        <span class="fw-semibold">{{ archiveProgress.current }} of {{ archiveProgress.total }}</span>
                      </div>
                      <div class="progress" style="height: 12px;">
                        <div class="progress-bar progress-bar-striped progress-bar-animated"
                             :style="{ width: archiveProgress.percentage + '%' }"
                             :class="{
                               'bg-success': archiveProgress.percentage === 100,
                               'bg-primary': archiveProgress.percentage < 100
                             }"
                             role="progressbar">
                          {{ archiveProgress.percentage }}%
                        </div>
                      </div>
                    </div>

                    <div v-if="archiveProgress.currentItem" class="text-center mb-3">
                      <p class="mb-1 text-muted">Currently processing:</p>
                      <span class="badge bg-info fs-6">{{ archiveProgress.currentItem }}</span>
                    </div>

                    <div v-if="archiveProgress.completed.length > 0" class="mb-3">
                      <h6 class="text-success">
                        <i class="bx bx-check-circle me-1"></i>
                        Successfully Archived ({{ archiveProgress.completed.length }})
                      </h6>
                      <div class="bg-light p-2 rounded" style="max-height: 120px; overflow-y: auto;">
                        <small>
                          <span v-for="(item, index) in archiveProgress.completed" :key="item" class="me-2">
                            {{ item }}<span v-if="index < archiveProgress.completed.length - 1">,</span>
                          </span>
                        </small>
                      </div>
                    </div>

                    <div v-if="archiveProgress.errors.length > 0" class="mb-3">
                      <h6 class="text-danger">
                        <i class="bx bx-error me-1"></i>
                        Errors ({{ archiveProgress.errors.length }})
                      </h6>
                      <div class="alert alert-danger p-2">
                        <small>
                          <ul class="mb-0 list-unstyled">
                            <li v-for="error in archiveProgress.errors" :key="error.billNo" class="mb-1">
                              <strong>{{ error.billNo }}:</strong> {{ error.message }}
                            </li>
                          </ul>
                        </small>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button v-if="archiveProgress.percentage === 100"
                            @click="closeArchiveProgressModal()"
                            type="button"
                            class="btn btn-success">
                      <i class="bx bx-check me-1"></i>
                      Complete
                    </button>
                    <button v-else
                            type="button"
                            class="btn btn-secondary"
                            disabled>
                      <i class="bx bx-time-five me-1 bx-spin"></i>
                      Processing...
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Restore Confirmation Modal -->
            <div class="modal fade" id="restoreConfirmationModal" aria-labelledby="restoreConfirmationModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-success text-white">
                    <h5 class="modal-title" id="restoreConfirmationModalLabel">
                      <i class="bx bx-refresh me-2"></i>
                      Restore Invoice
                    </h5>
                    <button type="button" class="btn-close btn-close-white" @click="closeRestoreModal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <div class="text-center mb-3">
                      <i class="bx bx-question-mark text-info" style="font-size: 48px;"></i>
                    </div>
                    <p class="text-center">
                      Are you sure you want to restore invoice <strong class="text-success">{{ currentRestoreBillNo }}</strong>?
                    </p>
                    <div class="alert alert-info">
                      <small>
                        <i class="bx bx-info-circle me-1"></i>
                        This will move the invoice back to the active billing system.
                      </small>
                    </div>
                    <div class="mb-3">
                      <label class="form-label">Restore Reason (Optional):</label>
                      <input v-model="restoreReason"
                             class="form-control"
                             type="text"
                             placeholder="Enter reason for restoration..."
                             maxlength="200">
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeRestoreModal">
                      <i class="bx bx-x me-1"></i>
                      Cancel
                    </button>
                    <button @click="executeRestore"
                            type="button"
                            class="btn btn-success"
                            :disabled="restoring">
                      <i class="bx bx-refresh me-1" :class="{ 'bx-spin': restoring }"></i>
                      <span v-if="restoring">Restoring...</span>
                      <span v-else>Restore Invoice</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- AUTO ARCHIVE SETUP MODAL -->
            <div class="modal fade" id="autoArchiveModal" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-warning text-white">
                    <h5 class="modal-title">
                      <i class="bx bx-time me-2"></i>Auto Archive Duplicates
                    </h5>
                    <button type="button" class="btn-close btn-close-white" @click="closeAutoArchiveModal"></button>
                  </div>
                  <div class="modal-body">
                    <p class="text-muted mb-3">
                      This will automatically search and archive duplicates for each day in the selected date range.
                    </p>

                    <div class="row g-3">
                      <div class="col-md-6">
                        <label class="form-label fw-bold">From Date <span class="text-danger">*</span></label>
                        <input v-model="autoArchive.dateFrom"
                               class="form-control"
                               type="date"
                               :max="autoArchive.dateTo || undefined">
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-bold">To Date <span class="text-danger">*</span></label>
                        <input v-model="autoArchive.dateTo"
                               class="form-control"
                               type="date"
                               :min="autoArchive.dateFrom || undefined">
                      </div>
                    </div>

                    <div class="row g-3 mt-2">
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Revenue Stream</label>
                        <select class="form-select" v-model="autoArchive.incomeTypePrefix">
                          <option value="">All Streams</option>
                          <option v-for="prefix in prefixes" :key="prefix.incomeTypePrefix" :value="prefix.incomeTypePrefix">
                            {{ prefix.stream }} ({{ prefix.incomeTypePrefix }})
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6">
                        <label class="form-label fw-bold">Sub County</label>
                        <select class="form-select" v-model="autoArchive.subCountyID">
                          <option value="">All Sub Counties</option>
                          <option v-for="county in subCounties" :key="county.subCountyID" :value="county.subCountyID">
                            {{ county.subCountyName }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="alert alert-warning mt-3 mb-0">
                      <i class="bx bx-info-circle me-2"></i>
                      <strong>Note:</strong> You can pause and resume this process at any time.
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeAutoArchiveModal">
                      Cancel
                    </button>
                    <button type="button"
                            class="btn btn-warning"
                            @click="startAutoArchive"
                            :disabled="!autoArchive.dateFrom || !autoArchive.dateTo">
                      <i class="bx bx-play me-1"></i>
                      Start Auto Archive
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- AUTO ARCHIVE PROGRESS MODAL -->
            <div class="modal fade" id="autoArchiveProgressModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                  <div class="modal-header bg-primary text-white">
                    <h5 class="modal-title text-white">
                      <i class="bx bx-time bx-spin me-2" v-if="!autoArchivePaused"></i>
                      <i class="bx bx-pause me-2" v-else></i>
                      Auto Archive {{ autoArchivePaused ? 'Paused' : 'in Progress' }}
                    </h5>
                  </div>
                  <div class="modal-body">
                    <!-- Overall Progress -->
                    <div class="mb-4">
                      <div class="d-flex justify-content-between mb-2">
                        <span class="fw-bold">Overall Progress</span>
                        <span class="text-muted">{{ autoArchive.currentDayIndex }} of {{ autoArchive.totalDays }} days</span>
                      </div>
                      <div class="progress" style="height: 25px;">
                        <div class="progress-bar progress-bar-striped"
                             :class="{ 'progress-bar-animated': !autoArchivePaused }"
                             role="progressbar"
                             :style="{width: autoArchive.overallProgress + '%'}"
                             :aria-valuenow="autoArchive.overallProgress"
                             aria-valuemin="0"
                             aria-valuemax="100">
                          {{ autoArchive.overallProgress }}%
                        </div>
                      </div>
                    </div>

                    <!-- Current Day Info -->
                    <div class="card bg-light mb-3">
                      <div class="card-body">
                        <h6 class="card-title mb-2">
                          <i class="bx bx-calendar me-2"></i>Current Day:
                          <span class="text-primary">{{ autoArchive.currentDate }}</span>
                        </h6>
                        <div class="row g-3 mt-2">
                          <div class="col-4">
                            <div class="text-center">
                              <div class="text-muted small">Searched</div>
                              <div class="h5 mb-0 text-info">{{ autoArchive.currentDaySearched }}</div>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="text-center">
                              <div class="text-muted small">Found</div>
                              <div class="h5 mb-0 text-warning">{{ autoArchive.currentDayFound }}</div>
                            </div>
                          </div>
                          <div class="col-4">
                            <div class="text-center">
                              <div class="text-muted small">Archived</div>
                              <div class="h5 mb-0 text-success">{{ autoArchive.currentDayArchived }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Summary Stats -->
                    <div class="row g-3 mb-3">
                      <div class="col-4">
                        <div class="card border-left-primary">
                          <div class="card-body p-3">
                            <div class="text-muted small">Total Searched</div>
                            <div class="h5 mb-0 text-primary">{{ autoArchive.totalSearched }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card border-left-warning">
                          <div class="card-body p-3">
                            <div class="text-muted small">Total Found</div>
                            <div class="h5 mb-0 text-warning">{{ autoArchive.totalFound }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-4">
                        <div class="card border-left-success">
                          <div class="card-body p-3">
                            <div class="text-muted small">Total Archived</div>
                            <div class="h5 mb-0 text-success">{{ autoArchive.totalArchived }}</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Activity Log -->
                    <div class="card">
                      <div class="card-header bg-white">
                        <h6 class="mb-0">
                          <i class="bx bx-list-ul me-2"></i>Activity Log
                        </h6>
                      </div>
                      <div class="card-body p-0">
                        <div class="activity-log" style="max-height: 200px; overflow-y: auto;">
                          <div v-for="(log, index) in autoArchive.logs"
                               :key="index"
                               class="log-entry p-2 border-bottom"
                               :class="log.type">
                            <small class="text-muted">{{ log.time }}</small>
                            <span class="ms-2">{{ log.message }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <!-- Pause/Resume Button -->
                    <button v-if="!autoArchivePaused"
                            type="button"
                            class="btn btn-warning"
                            @click="pauseAutoArchive"
                            :disabled="!autoArchiveInProgress">
                      <i class="bx bx-pause me-1"></i>
                      Pause
                    </button>
                    <button v-else
                            type="button"
                            class="btn btn-success"
                            @click="resumeAutoArchive">
                      <i class="bx bx-play me-1"></i>
                      Resume
                    </button>

                    <!-- Stop Button -->
                    <button type="button"
                            class="btn btn-danger"
                            @click="stopAutoArchive"
                            :disabled="!autoArchiveInProgress && !autoArchivePaused">
                      <i class="bx bx-stop me-1"></i>
                      Stop Process
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alerts -->
            <div class="position-fixed top-0 end-0 p-3" style="z-index: 11000;">
              <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                <i class="bx bx-check-circle me-2"></i>
                {{ message }}
                <button @click="clearAlerts" type="button" class="btn-close"></button>
              </div>
              <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                {{ message }}
                <button @click="clearAlerts" type="button" class="btn-close"></button>
              </div>
              <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                {{ message }}
                <button @click="clearAlerts" type="button" class="btn-close"></button>
              </div>
            </div>

          </div>
        </div>
        <!-- Footer -->
        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                  Duplicate Invoice Management
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import { biller, execute } from "@/api";
import router from "@/router";
import moment from "moment";

export default {
  name: "DuplicateInvoiceManagement",
  components: { NavigationBar },
  data() {
    return {
      // Tab management
      activeTab: 'duplicates',

      // Loading states
      loading: false,
      loadingArchived: false,
      archiving: false,
      restoring: false,

      // Filters for duplicate search
      filters: {
        dateFrom: '',
        dateTo: '',
        incomeTypePrefix: '',
        subCountyID: ''
      },

      // Archive filters
      archiveFilters: {
        dateFrom: '',
        dateTo: '',
        incomeTypePrefix: '',
        subCountyID: ''
      },

      // Auto Archive Data
      autoArchive: {
        dateFrom: '',
        dateTo: '',
        incomeTypePrefix: '',
        subCountyID: '',
        currentDate: '',
        currentDayIndex: 0,
        totalDays: 0,
        overallProgress: 0,
        currentDaySearched: 0,
        currentDayFound: 0,
        currentDayArchived: 0,
        totalSearched: 0,
        totalFound: 0,
        totalArchived: 0,
        logs: [],
        // Pause/Resume tracking
        pauseRequested: false,
        pausedDate: null,
        pausedDateIndex: 0
      },
      autoArchiveInProgress: false,
      autoArchivePaused: false,
      autoArchiveStopped: false,

      // Data
      duplicates: [],
      archivedInvoices: [],
      prefixes: [],
      subCounties: [],

      // Selection
      selectedInvoices: [],

      // Progress tracking
      archiveProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        currentItem: '',
        completed: [],
        errors: []
      },

      // Archive settings
      bulkArchiveReason: '',
      singleArchiveReason: '',
      restoreReason: '',

      // Current operation tracking
      currentArchiveBillNo: '',
      currentRestoreBillNo: '',

      // Pagination
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_records: 0,
        limit: 50
      },

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Modal instances (will be populated on mount)
      bulkArchiveModal: null,
      singleArchiveModal: null,
      archiveProgressModal: null,
      restoreModal: null,
      autoArchiveModal: null,
      autoArchiveProgressModal: null
    }
  },
  computed: {
    duplicatesOnly() {
      return this.duplicates.filter(item => item.record_type === 'DUPLICATE');
    },

    duplicatesFound() {
      return this.duplicatesOnly.length;
    },

    duplicateGroups() {
      if (this.duplicates.length === 0) return 0;
      return new Set(this.duplicates.map(item => item.original_bill)).size;
    },

    duplicateAmount() {
      return this.duplicatesOnly.reduce((sum, item) => sum + parseFloat(item.detailAmount || 0), 0);
    },

    allVisibleDuplicatesSelected() {
      const visibleDuplicates = this.duplicatesOnly.map(item => item.billNo);
      return visibleDuplicates.length > 0 && visibleDuplicates.every(billNo => this.selectedInvoices.includes(billNo));
    },

    visiblePages() {
      const current = this.pagination.current_page;
      const total = this.pagination.total_pages;
      const pages = [];

      const start = Math.max(1, current - 2);
      const end = Math.min(total, current + 2);

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },
  mounted() {
    // Clean up any existing modal issues before initialization
    this.cleanupModalIssues();

    this.setDefaultDates();
    this.loadDropdownData();

    // Initialize modals after a delay to ensure DOM is ready
    setTimeout(() => {
      this.initializeModals();
    }, 500);

    this.menuAccess();
  },
  beforeDestroy() {
    // Clean up modals when component is destroyed
    this.destroyModals();
  },
  methods: {
    // Clean up any existing modal issues
    cleanupModalIssues() {
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
      document.body.style.removeProperty('padding-right');
      document.body.style.removeProperty('overflow');

      // Remove any existing modal backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    },

    // Destroy all modal instances
    destroyModals() {
      if (this.bulkArchiveModal) {
        this.bulkArchiveModal.dispose();
        this.bulkArchiveModal = null;
      }
      if (this.singleArchiveModal) {
        this.singleArchiveModal.dispose();
        this.singleArchiveModal = null;
      }
      if (this.archiveProgressModal) {
        this.archiveProgressModal.dispose();
        this.archiveProgressModal = null;
      }
      if (this.restoreModal) {
        this.restoreModal.dispose();
        this.restoreModal = null;
      }
      if (this.autoArchiveModal) {
        this.autoArchiveModal.dispose();
        this.autoArchiveModal = null;
      }
      if (this.autoArchiveProgressModal) {
        this.autoArchiveProgressModal.dispose();
        this.autoArchiveProgressModal = null;
      }

      // Final cleanup
      this.cleanupModalIssues();
    },

    // Initialize modals - FIXED VERSION
    initializeModals() {
      this.$nextTick(() => {
        // First ensure cleanup
        this.cleanupModalIssues();

        if (typeof window !== 'undefined' && window.bootstrap) {
          // Initialize Bulk Archive Modal
          const bulkArchiveModalEl = document.getElementById('bulkArchiveConfirmationModal');
          if (bulkArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(bulkArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.bulkArchiveModal = new bootstrap.Modal(bulkArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            bulkArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Initialize Single Archive Modal
          const singleArchiveModalEl = document.getElementById('singleArchiveConfirmationModal');
          if (singleArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(singleArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.singleArchiveModal = new bootstrap.Modal(singleArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            singleArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Initialize Archive Progress Modal
          const archiveProgressModalEl = document.getElementById('archiveProgressModal');
          if (archiveProgressModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(archiveProgressModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.archiveProgressModal = new bootstrap.Modal(archiveProgressModalEl, {
              backdrop: 'static',
              keyboard: false
            });

            archiveProgressModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Initialize Restore Modal
          const restoreModalEl = document.getElementById('restoreConfirmationModal');
          if (restoreModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(restoreModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.restoreModal = new bootstrap.Modal(restoreModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            restoreModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Initialize Auto Archive Modal
          const autoArchiveModalEl = document.getElementById('autoArchiveModal');
          if (autoArchiveModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(autoArchiveModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.autoArchiveModal = new bootstrap.Modal(autoArchiveModalEl, {
              backdrop: true,
              keyboard: true,
              focus: true
            });

            autoArchiveModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }

          // Initialize Auto Archive Progress Modal
          const autoArchiveProgressModalEl = document.getElementById('autoArchiveProgressModal');
          if (autoArchiveProgressModalEl) {
            const existingInstance = bootstrap.Modal.getInstance(autoArchiveProgressModalEl);
            if (existingInstance) {
              existingInstance.dispose();
            }

            this.autoArchiveProgressModal = new bootstrap.Modal(autoArchiveProgressModalEl, {
              backdrop: 'static',
              keyboard: false
            });

            autoArchiveProgressModalEl.addEventListener('hidden.bs.modal', () => {
              this.cleanupModalIssues();
            });
          }
        }
      });
    },

    // Initialize default dates
    setDefaultDates() {
      const today = moment();
      this.filters.dateTo = today.format('YYYY-MM-DD');
      this.filters.dateFrom = today.subtract(7, 'days').format('YYYY-MM-DD');

      this.archiveFilters.dateTo = moment().format('YYYY-MM-DD');
      this.archiveFilters.dateFrom = moment().subtract(30, 'days').format('YYYY-MM-DD');
    },

    // Load dropdown data
    async loadDropdownData() {
      await Promise.all([
        this.loadPrefixes(),
        this.loadSubCounties()
      ]);
    },

    // Load income type prefixes
    async loadPrefixes() {
      try {
        const data = new FormData();
        data.append("function", "getIncomeTypePrefixes");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.prefixes = response.data.data.prefixes || [];
        }
      } catch (error) {
        console.error('Error loading prefixes:', error);
      }
    },

    // Load sub counties
    async loadSubCounties() {
      try {
        const data = new FormData();
        data.append("function", "getSubCountiesForDuplicates");

        const response = await execute(data, biller);
        if (response.data.success) {
          this.subCounties = response.data.data.subCounties || [];
        }
      } catch (error) {
        console.error('Error loading sub counties:', error);
      }
    },

    // Search for duplicate invoices
    async searchDuplicates() {
      if (!this.filters.dateFrom || !this.filters.dateTo) {
        this.showAlert('failed', 'Please select date range');
        return;
      }

      this.loading = true;
      this.duplicates = [];
      this.selectedInvoices = [];

      try {
        const data = new FormData();
        data.append("function", "getDuplicateInvoices");
        data.append("dateFrom", this.filters.dateFrom);
        data.append("dateTo", this.filters.dateTo);

        if (this.filters.incomeTypePrefix) {
          data.append("incomeTypePrefix", this.filters.incomeTypePrefix);
        }

        if (this.filters.subCountyID) {
          data.append("subCountyID", this.filters.subCountyID);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.duplicates = response.data.data.all_records || [];

          if (this.duplicates.length > 0) {
            const summary = response.data.data.summary;
            this.showAlert('success', `Found ${summary.duplicate_records} duplicate invoices in ${summary.duplicate_groups} groups`);
          } else {
            this.showAlert('info', 'No duplicate UNPAID invoices found for the selected criteria');
          }
        } else {
          this.showAlert('failed', response.data.message || 'Error searching for duplicates');
        }
      } catch (error) {
        console.error('Error searching duplicates:', error);
        this.showAlert('failed', 'An error occurred while searching for duplicates');
      } finally {
        this.loading = false;
      }
    },

    // FIXED Modal Methods
    showBulkArchiveConfirmation() {
      if (this.selectedInvoices.length === 0) {
        this.showAlert('failed', 'Please select invoices to archive');
        return;
      }

      this.bulkArchiveReason = '';

      // Clean up before showing
      this.cleanupModalIssues();

      // Show modal with a small delay
      setTimeout(() => {
        if (this.bulkArchiveModal) {
          this.bulkArchiveModal.show();
        }
      }, 100);
    },

    closeBulkArchiveModal() {
      if (this.bulkArchiveModal) {
        this.bulkArchiveModal.hide();
      }
      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    showSingleArchiveConfirmation(billNo) {
      this.currentArchiveBillNo = billNo;
      this.singleArchiveReason = '';

      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.singleArchiveModal) {
          this.singleArchiveModal.show();
        }
      }, 100);
    },

    closeSingleArchiveModal() {
      if (this.singleArchiveModal) {
        this.singleArchiveModal.hide();
      }
      this.currentArchiveBillNo = '';

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    showArchiveProgress() {
      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.archiveProgressModal) {
          this.archiveProgressModal.show();
        }
      }, 100);
    },

    closeArchiveProgressModal() {
      if (this.archiveProgressModal) {
        this.archiveProgressModal.hide();
      }

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    showRestoreConfirmation(billNo) {
      this.currentRestoreBillNo = billNo;
      this.restoreReason = '';

      this.cleanupModalIssues();

      setTimeout(() => {
        if (this.restoreModal) {
          this.restoreModal.show();
        }
      }, 100);
    },

    closeRestoreModal() {
      if (this.restoreModal) {
        this.restoreModal.hide();
      }
      this.currentRestoreBillNo = '';

      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    // Execute bulk archive
    async executeBulkArchive() {
      if (this.selectedInvoices.length === 0) {
        this.showAlert('failed', 'No invoices selected');
        return;
      }

      // Close confirmation modal and show progress modal
      this.closeBulkArchiveModal();

      setTimeout(() => {
        this.showArchiveProgress();
      }, 400);

      // Initialize progress
      this.archiveProgress = {
        current: 0,
        total: this.selectedInvoices.length,
        percentage: 0,
        currentItem: '',
        completed: [],
        errors: []
      };

      this.archiving = true;

      // Process each invoice one by one
      for (let i = 0; i < this.selectedInvoices.length; i++) {
        const billNo = this.selectedInvoices[i];
        this.archiveProgress.current = i + 1;
        this.archiveProgress.currentItem = billNo;
        this.archiveProgress.percentage = Math.round((this.archiveProgress.current / this.archiveProgress.total) * 100);

        try {
          await this.archiveInvoice(billNo, this.bulkArchiveReason || "Bulk duplicate removal");

          // Add to completed list
          this.archiveProgress.completed.push(billNo);

          // Remove from duplicates list on success
          this.duplicates = this.duplicates.filter(item => item.billNo !== billNo);

        } catch (error) {
          this.archiveProgress.errors.push({
            billNo: billNo,
            message: error.message || 'Unknown error'
          });
        }

        // Small delay between requests to prevent overwhelming the server
        if (i < this.selectedInvoices.length - 1) {
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }

      // Clear selection
      this.selectedInvoices = [];
      this.archiving = false;

      // Show completion message
      const successful = this.archiveProgress.completed.length;
      if (successful > 0) {
        this.showAlert('success', `Successfully archived ${successful} duplicate invoices`);
      }

      if (this.archiveProgress.errors.length > 0) {
        this.showAlert('failed', `${this.archiveProgress.errors.length} invoices failed to archive`);
      }
    },

    // Execute single archive
    async executeSingleArchive() {
      if (!this.currentArchiveBillNo) {
        this.showAlert('failed', 'No invoice selected for archiving');
        return;
      }

      this.archiving = true;

      try {
        await this.archiveInvoice(this.currentArchiveBillNo, this.singleArchiveReason || "Manual duplicate removal");

        // Remove from list
        this.duplicates = this.duplicates.filter(item => item.billNo !== this.currentArchiveBillNo);
        this.selectedInvoices = this.selectedInvoices.filter(id => id !== this.currentArchiveBillNo);

        this.showAlert('success', `Invoice ${this.currentArchiveBillNo} archived successfully`);
        this.closeSingleArchiveModal();
      } catch (error) {
        this.showAlert('failed', error.message || 'Failed to archive invoice');
      } finally {
        this.archiving = false;
      }
    },

    // Archive single invoice (API call)
    async archiveInvoice(billNo, reason = '') {
      const data = new FormData();
      data.append("function", "archiveDuplicateInvoice");
      data.append("billNo", billNo);
      data.append("archivedBy", sessionStorage.getItem("sessionNames") || "System");
      data.append("archiveReason", reason);

      const response = await execute(data, biller);

      if (!response.data.success) {
        throw new Error(response.data.message || 'Failed to archive invoice');
      }

      return response.data;
    },

    // Load archived invoices
    async loadArchivedInvoices(page = 1) {
      if (!this.archiveFilters.dateFrom || !this.archiveFilters.dateTo) {
        this.showAlert('failed', 'Please select date range for archived invoices');
        return;
      }

      this.loadingArchived = true;

      try {
        const data = new FormData();
        data.append("function", "getArchivedInvoices");
        data.append("dateFrom", this.archiveFilters.dateFrom);
        data.append("dateTo", this.archiveFilters.dateTo);
        data.append("page", page.toString());
        data.append("limit", this.pagination.limit.toString());

        if (this.archiveFilters.incomeTypePrefix) {
          data.append("incomeTypePrefix", this.archiveFilters.incomeTypePrefix);
        }

        if (this.archiveFilters.subCountyID) {
          data.append("subCountyID", this.archiveFilters.subCountyID);
        }

        const response = await execute(data, biller);

        if (response.data.success) {
          this.archivedInvoices = response.data.data.archived_invoices || [];
          this.pagination = response.data.data.pagination || this.pagination;
        } else {
          this.showAlert('info', response.data.message || 'No archived invoices found');
          this.archivedInvoices = [];
        }
      } catch (error) {
        console.error('Error loading archived invoices:', error);
        this.showAlert('failed', 'Error loading archived invoices');
      } finally {
        this.loadingArchived = false;
      }
    },

    // Execute restore
    async executeRestore() {
      if (!this.currentRestoreBillNo) {
        this.showAlert('failed', 'No invoice selected for restoration');
        return;
      }

      this.restoring = true;

      try {
        const data = new FormData();
        data.append("function", "restoreArchivedInvoice");
        data.append("billNo", this.currentRestoreBillNo);
        data.append("restoredBy", sessionStorage.getItem("sessionNames") || "System");
        data.append("restoreReason", this.restoreReason || "Manual restoration from duplicate management");

        const response = await execute(data, biller);

        if (response.data.success) {
          // Remove from archived list
          this.archivedInvoices = this.archivedInvoices.filter(item => item.billNo !== this.currentRestoreBillNo);
          this.showAlert('success', `Invoice ${this.currentRestoreBillNo} restored successfully`);
          this.closeRestoreModal();
        } else {
          this.showAlert('failed', response.data.message || 'Failed to restore invoice');
        }
      } catch (error) {
        console.error('Error restoring invoice:', error);
        this.showAlert('failed', 'Error restoring invoice');
      } finally {
        this.restoring = false;
      }
    },

    // AUTO ARCHIVE METHODS
    openAutoArchiveModal() {
      // Pre-populate with current filter dates if available
      if (this.filters.dateFrom) {
        this.autoArchive.dateFrom = this.filters.dateFrom;
      }
      if (this.filters.dateTo) {
        this.autoArchive.dateTo = this.filters.dateTo;
      }
      this.autoArchive.incomeTypePrefix = this.filters.incomeTypePrefix;
      this.autoArchive.subCountyID = this.filters.subCountyID;

      this.cleanupModalIssues();
      setTimeout(() => {
        if (this.autoArchiveModal) {
          this.autoArchiveModal.show();
        }
      }, 100);
    },

    closeAutoArchiveModal() {
      if (this.autoArchiveModal) {
        this.autoArchiveModal.hide();
      }
      setTimeout(() => {
        this.cleanupModalIssues();
      }, 300);
    },

    async startAutoArchive() {
      if (!this.autoArchive.dateFrom || !this.autoArchive.dateTo) {
        this.showAlert('failed', 'Please select both From and To dates');
        return;
      }

      // Validate date range
      const fromDate = new Date(this.autoArchive.dateFrom);
      const toDate = new Date(this.autoArchive.dateTo);

      if (fromDate > toDate) {
        this.showAlert('failed', 'From Date cannot be after To Date');
        return;
      }

      // Reset progress tracking
      this.autoArchive.currentDayIndex = 0;
      this.autoArchive.overallProgress = 0;
      this.autoArchive.currentDaySearched = 0;
      this.autoArchive.currentDayFound = 0;
      this.autoArchive.currentDayArchived = 0;
      this.autoArchive.totalSearched = 0;
      this.autoArchive.totalFound = 0;
      this.autoArchive.totalArchived = 0;
      this.autoArchive.logs = [];
      this.autoArchive.pauseRequested = false;
      this.autoArchive.pausedDate = null;
      this.autoArchive.pausedDateIndex = 0;
      this.autoArchiveStopped = false;
      this.autoArchivePaused = false;

      // Calculate total days
      const daysDiff = Math.ceil((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
      this.autoArchive.totalDays = daysDiff;

      // Close setup modal and show progress modal
      this.closeAutoArchiveModal();

      setTimeout(() => {
        this.cleanupModalIssues();
        setTimeout(() => {
          if (this.autoArchiveProgressModal) {
            this.autoArchiveProgressModal.show();
          }
        }, 100);
      }, 400);

      this.autoArchiveInProgress = true;
      this.addLog('info', 'Auto Archive process started');
      this.addLog('info', `Processing ${daysDiff} day(s) from ${this.autoArchive.dateFrom} to ${this.autoArchive.dateTo}`);

      // Process each day
      await this.processAutoArchive(fromDate, toDate);
    },

    async processAutoArchive(fromDate, toDate) {
      const currentDate = new Date(fromDate);

      // If resuming, start from paused date
      if (this.autoArchive.pausedDate) {
        currentDate.setTime(new Date(this.autoArchive.pausedDate).getTime());
        this.autoArchive.currentDayIndex = this.autoArchive.pausedDateIndex;
        this.addLog('info', `Resuming from ${this.autoArchive.pausedDate}`);
      }

      while (currentDate <= toDate && !this.autoArchiveStopped && !this.autoArchive.pauseRequested) {
        const dateStr = currentDate.toISOString().split('T')[0];

        // Update current date display
        this.autoArchive.currentDate = dateStr;
        this.autoArchive.currentDayIndex++;
        this.autoArchive.currentDaySearched = 0;
        this.autoArchive.currentDayFound = 0;
        this.autoArchive.currentDayArchived = 0;

        this.addLog('processing', `Processing date: ${dateStr}`);

        try {
          // Search for duplicates on this day
          const searchData = new FormData();
          searchData.append("function", "getDuplicateInvoices");
          searchData.append("dateFrom", dateStr);
          searchData.append("dateTo", dateStr);
          searchData.append("incomeTypePrefix", this.autoArchive.incomeTypePrefix);
          searchData.append("subCountyID", this.autoArchive.subCountyID);

          const searchResponse = await execute(searchData, biller);

          if (searchResponse && searchResponse.data && searchResponse.data.success) {
            const allRecords = searchResponse.data.data.all_records || [];
            const duplicateRecords = allRecords.filter(item => item.record_type === 'DUPLICATE');
            const duplicateGroups = new Set(allRecords.map(item => item.original_bill)).size;

            this.autoArchive.currentDaySearched = duplicateGroups;
            this.autoArchive.currentDayFound = duplicateRecords.length;
            this.autoArchive.totalSearched += duplicateGroups;
            this.autoArchive.totalFound += duplicateRecords.length;

            if (duplicateRecords.length > 0) {
              this.addLog('warning', `Found ${duplicateRecords.length} duplicate(s) in ${duplicateGroups} group(s)`);

              // Archive each duplicate
              let archived = 0;
              for (const record of duplicateRecords) {
                if (this.autoArchiveStopped || this.autoArchive.pauseRequested) break;

                try {
                  await this.archiveInvoice(record.billNo, "Auto-archive: Duplicate invoice removal");
                  archived++;
                  this.autoArchive.currentDayArchived = archived;
                  this.autoArchive.totalArchived++;
                } catch (error) {
                  this.addLog('error', `Failed to archive ${record.billNo}: ${error.message}`);
                }

                // Small delay between archives
                await new Promise(resolve => setTimeout(resolve, 100));
              }

              if (archived > 0) {
                this.addLog('success', `Archived ${archived} duplicate(s)`);
              }
            } else {
              this.addLog('info', `No duplicates found for ${dateStr}`);
            }
          }
        } catch (error) {
          console.error(`Error processing date ${dateStr}:`, error);
          this.addLog('error', `Error processing ${dateStr}: ${error.message}`);
        }

        // Update progress
        this.autoArchive.overallProgress = Math.round((this.autoArchive.currentDayIndex / this.autoArchive.totalDays) * 100);

        // Check for pause before moving to next day
        if (this.autoArchive.pauseRequested) {
          this.autoArchive.pausedDate = dateStr;
          this.autoArchive.pausedDateIndex = this.autoArchive.currentDayIndex;
          this.autoArchiveInProgress = false;
          this.autoArchivePaused = true;
          this.addLog('warning', 'Auto Archive process paused');
          this.showAlert('info', `Auto Archive paused at ${dateStr}`);
          return;
        }

        // Move to next day
        currentDate.setDate(currentDate.getDate() + 1);

        // Small delay to allow UI to update
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      // Process complete
      this.autoArchiveInProgress = false;

      if (this.autoArchiveStopped) {
        this.addLog('warning', 'Auto Archive process stopped by user');
        this.showAlert('info', `Auto Archive stopped. Processed ${this.autoArchive.currentDayIndex} day(s), archived ${this.autoArchive.totalArchived} invoice(s)`);
        // Reset pause state
        this.autoArchive.pausedDate = null;
        this.autoArchive.pausedDateIndex = 0;
        this.autoArchivePaused = false;
      } else if (!this.autoArchive.pauseRequested) {
        this.addLog('success', 'Auto Archive process completed successfully');
        this.showAlert('success', `Auto Archive complete! Processed ${this.autoArchive.totalDays} day(s), archived ${this.autoArchive.totalArchived} invoice(s)`);

        // Auto-close progress modal after 3 seconds
        setTimeout(() => {
          if (this.autoArchiveProgressModal) {
            this.autoArchiveProgressModal.hide();
          }
          setTimeout(() => {
            this.cleanupModalIssues();
          }, 300);
        }, 3000);
      }
    },

    pauseAutoArchive() {
      this.autoArchive.pauseRequested = true;
      this.addLog('warning', 'Pause requested, will pause after current day completes...');
    },

    async resumeAutoArchive() {
      if (!this.autoArchive.pausedDate) {
        this.showAlert('failed', 'No paused state found');
        return;
      }

      this.autoArchive.pauseRequested = false;
      this.autoArchivePaused = false;
      this.autoArchiveInProgress = true;

      this.addLog('info', 'Resuming Auto Archive process...');

      // Continue from where we left off
      const toDate = new Date(this.autoArchive.dateTo);
      const resumeDate = new Date(this.autoArchive.pausedDate);

      // Move to next day after the paused one
      resumeDate.setDate(resumeDate.getDate() + 1);

      await this.processAutoArchive(resumeDate, toDate);
    },

    stopAutoArchive() {
      this.autoArchiveStopped = true;
      this.autoArchiveInProgress = false;
      this.autoArchivePaused = false;
      this.autoArchive.pauseRequested = false;
      this.autoArchive.pausedDate = null;
      this.autoArchive.pausedDateIndex = 0;
      this.addLog('warning', 'Stopping auto archive process...');
    },

    addLog(type, message) {
      const now = new Date();
      const time = now.toLocaleTimeString();

      this.autoArchive.logs.unshift({
        type,
        time,
        message
      });

      // Keep only last 50 logs
      if (this.autoArchive.logs.length > 50) {
        this.autoArchive.logs.pop();
      }
    },

    // Selection methods
    selectAllDuplicates() {
      this.selectedInvoices = this.duplicatesOnly.map(item => item.billNo);
    },

    clearSelection() {
      this.selectedInvoices = [];
    },

    toggleSelectAllVisible() {
      if (this.allVisibleDuplicatesSelected) {
        // Deselect all visible duplicates
        const visibleBillNos = this.duplicatesOnly.map(item => item.billNo);
        this.selectedInvoices = this.selectedInvoices.filter(billNo => !visibleBillNos.includes(billNo));
      } else {
        // Select all visible duplicates
        const visibleBillNos = this.duplicatesOnly.map(item => item.billNo);
        visibleBillNos.forEach(billNo => {
          if (!this.selectedInvoices.includes(billNo)) {
            this.selectedInvoices.push(billNo);
          }
        });
      }
    },

    // Pagination
    changePage(page) {
      if (page >= 1 && page <= this.pagination.total_pages) {
        this.loadArchivedInvoices(page);
      }
    },

    // Utility methods
    setDateRange(preset) {
      const today = moment();

      switch(preset) {
        case 'today':
          this.filters.dateFrom = today.format('YYYY-MM-DD');
          this.filters.dateTo = today.format('YYYY-MM-DD');
          break;
        case 'week':
          this.filters.dateFrom = today.startOf('week').format('YYYY-MM-DD');
          this.filters.dateTo = today.endOf('week').format('YYYY-MM-DD');
          break;
        case 'month':
          this.filters.dateFrom = today.startOf('month').format('YYYY-MM-DD');
          this.filters.dateTo = today.endOf('month').format('YYYY-MM-DD');
          break;
      }

      this.clearResults();
    },

    clearResults() {
      this.duplicates = [];
      this.selectedInvoices = [];
    },

    formatPrice(value) {
      const num = parseFloat(value) || 0;
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      }).format(num);
    },

    formatDateTime(dateString) {
      if (!dateString) return '';
      return moment(dateString).format('MMM DD, YYYY HH:mm');
    },

    // Navigation
    gotTo(route) {
      router.push(route);
    },

    // Alerts
    clearAlerts() {
      this.alert = { success: false, info: false, failed: false };
      this.message = '';
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      setTimeout(() => {
        this.clearAlerts();
      }, 5000);
    },

    // Menu access logging
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Duplicate Invoice Management");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
/* CRITICAL MODAL FIX STYLES */
.modal-backdrop {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1040 !important;
  width: 100vw !important;
  height: 100vh !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1055 !important;
  width: 100% !important;
  height: 100% !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  outline: 0 !important;
  pointer-events: none !important;
}

.modal.show {
  pointer-events: auto !important;
}

.modal-dialog {
  position: relative !important;
  width: auto !important;
  margin: 1.75rem auto !important;
  pointer-events: none !important;
}

.modal-content {
  position: relative !important;
  display: flex !important;
  flex-direction: column !important;
  width: 100% !important;
  pointer-events: auto !important;
  background-color: #fff !important;
  background-clip: padding-box !important;
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  border-radius: 0.3rem !important;
  outline: 0 !important;
}

/* Specific modal z-index to ensure it's on top */
#bulkArchiveConfirmationModal,
#singleArchiveConfirmationModal,
#archiveProgressModal,
#restoreConfirmationModal,
#autoArchiveModal,
#autoArchiveProgressModal {
  z-index: 10050 !important;
}

#bulkArchiveConfirmationModal .modal-dialog,
#singleArchiveConfirmationModal .modal-dialog,
#archiveProgressModal .modal-dialog,
#restoreConfirmationModal .modal-dialog,
#autoArchiveModal .modal-dialog,
#autoArchiveProgressModal .modal-dialog {
  z-index: 10060 !important;
}

/* Toast notification should be above modals */
.toast-container {
  z-index: 11000 !important;
}

/* Stats cards */
.mini-stats-wid {
  transition: all 0.3s ease;
}

.mini-stats-wid:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.mini-stats-wid.border-warning {
  border-left: 3px solid #ffc107;
}

.mini-stats-wid.border-info {
  border-left: 3px solid #17a2b8;
}

.mini-stats-wid.border-danger {
  border-left: 3px solid #dc3545;
}

.mini-stats-wid.border-success {
  border-left: 3px solid #28a745;
}

/* Table styles */
.table-success {
  background-color: rgba(40, 167, 69, 0.1) !important;
}

.table-warning {
  background-color: rgba(255, 193, 7, 0.1) !important;
}

.table-light {
  background-color: rgba(248, 249, 250, 0.5) !important;
}

/* Progress bar */
.progress {
  height: 20px;
}

.progress-bar {
  font-size: 0.75rem;
  font-weight: 600;
}

/* Badge */
.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

/* Tabs */
.nav-tabs .nav-link {
  color: #495057;
  border: 1px solid transparent;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

/* Form controls */
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}

/* Buttons */
.btn-group .btn {
  font-size: 0.875rem;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Avatar */
.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

/* Animations */
.bx-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Progress bar stripes */
.progress-bar-striped {
  background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
  background-size: 1rem 1rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@keyframes progress-bar-stripes {
  0% { background-position-x: 1rem; }
}

/* Modal size */
.modal-lg {
  max-width: 800px;
}

/* Fix body overflow when modal is open */
body.modal-open {
  overflow: hidden !important;
  padding-right: 0 !important;
}

/* Auto Archive specific styles */
.activity-log {
  background-color: #f8f9fa;
}

.log-entry {
  font-size: 0.875rem;
}

.log-entry.success {
  border-left: 3px solid #28a745;
  background-color: rgba(40, 167, 69, 0.05);
}

.log-entry.error {
  border-left: 3px solid #dc3545;
  background-color: rgba(220, 53, 69, 0.05);
}

.log-entry.warning {
  border-left: 3px solid #ffc107;
  background-color: rgba(255, 193, 7, 0.05);
}

.log-entry.info {
  border-left: 3px solid #17a2b8;
  background-color: rgba(23, 162, 184, 0.05);
}

.log-entry.processing {
  border-left: 3px solid #0d6efd;
  background-color: rgba(13, 110, 253, 0.05);
}

.border-left-primary {
  border-left: 3px solid #0d6efd;
}

.border-left-warning {
  border-left: 3px solid #ffc107;
}

.border-left-success {
  border-left: 3px solid #28a745;
}
</style>